import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function YouTubeIcon({ ...props }) {
  return (
    <SvgIcon
      width="473.931"
      height="473.931"
      viewBox="0 0 473.931 473.931"
      fill="#fff"
      {...props}
    >
      <circle fill="#D42428" cx="236.966" cy="236.966" r="236.966" />
      <path
        fill="#D42428"
        d="M404.518,69.38c92.541,92.549,92.549,242.593,0,335.142c-92.541,92.541-242.593,92.545-335.142,0
	L404.518,69.38z"
      />
      <path
        fill="#D42428"
        d="M469.168,284.426L351.886,167.148l-138.322,15.749l-83.669,129.532l156.342,156.338
	C378.157,449.322,450.422,376.612,469.168,284.426z"
      />
      <path
        fill="#FFFFFF"
        d="M360.971,191.238c0-19.865-16.093-35.966-35.947-35.966H156.372c-19.85,0-35.94,16.105-35.94,35.966
	v96.444c0,19.865,16.093,35.966,35.94,35.966h168.649c19.858,0,35.947-16.105,35.947-35.966v-96.444H360.971z M216.64,280.146
	v-90.584l68.695,45.294L216.64,280.146z"
      />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </SvgIcon>
  );
}
